<app-layout>
  <app-voltar route="listagem/servicos" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form
      [formGroup]="form"
      [ngStyle]="!isViewing ? { 'margin-bottom': '48px' } : {}"
      (ngModelChange)="clearForms()">
      <div class="formList">
        <app-input
          type="text"
          label="Placa do Cavalo"
          placeholder="Digite a placa do cavalo"
          name="TX_PLCA_CAVA"
          formControlName="TX_PLCA_CAVA"
          mask="AAA-0A00"
          [requiredInput]="!isViewing"
          (blurEvent)="getEntrada()"></app-input>
        <app-input
          type="number"
          label="N° do Agendamento"
          placeholder="Digite o número do agendamento"
          name="PK_AGND"
          formControlName="PK_AGND"
          (blurEvent)="getEntrada()"></app-input>
        <app-input
          type="disabled"
          label="Data/Hora da Entrada no Gate"
          name="DT_GATE_ENTR"
          placeholder="Digite aqui"
          formControlName="DT_GATE_ENTR"></app-input>
        <app-input
          type="disabled"
          label="Data/Hora da Fila"
          name="DT_FILA"
          formControlName="DT_FILA"
          [requiredInput]="true"></app-input>
        <app-input
          type="select"
          label="Serviço"
          name="FK_SRVC"
          formControlName="FK_SRVC"
          [requiredInput]="!isViewing"
          [selectData]="servicoOptions"
          (ngModelChange)="escolherServico($event)">
        </app-input>
        <app-input
          type="select"
          label="Tipo da Carreta"
          name="FK_TIPO_CRRT"
          formControlName="FK_TIPO_CRRT"
          [selectData]="tipoCarretaOptions"
          (ngModelChange)="escolherTipoCarreta($event)"></app-input>
        <app-input
          type="select"
          label="Quantidade de Eixos"
          name="QT_TOTL_EIXO"
          formControlName="QT_TOTL_EIXO"
          [selectData]="tipoEixosOptions"
          (ngModelChange)="escolherQuantidadeEixo($event)"></app-input>
        <app-input
          type="select"
          label="Quantidade de Compartimentos"
          name="QT_CPTM"
          formControlName="QT_CPTM"
          [selectData]="qtdCompartimentosOptions"
          (ngModelChange)="escolherCompartimento($event)"></app-input>
        <app-input
          type="select"
          label="Tipo Carga"
          name="FK_CRGA"
          formControlName="FK_CRGA"
          [selectData]="tipoCargaOptions"
          (ngModelChange)="escolherCarga($event)"></app-input>
        <app-input
          type="text"
          label="Observação"
          placeholder="Digite aqui"
          name="TX_OBSV_SRVC_ENTR"
          formControlName="TX_OBSV_SRVC_ENTR"></app-input>
        <app-input
          type="select"
          label="Tabela de Preço"
          id="tabelaPreco"
          name="PK_PRCO"
          formControlName="PK_PRCO"
          [selectData]="precosOptions"
          (ngModelChange)="onPrecoSelecionado($event)"></app-input>
      </div>
      <app-botao
        *ngIf="!isViewing"
        type="cadastro"
        class="botao-cadastro"
        [text]="isEditing ? 'Editar Serviço' : 'Registrar Serviço'"
        (click)="postDados()"
        [disabled]="!form.get('PK_PRCO')?.value"></app-botao>
    </form>
  </div>

  <div class="tabela">
    <app-tabela-form
      *ngIf="!isLoading && this.tableData.length"
      [data]="tableData"
      [columns]="tableColumns"></app-tabela-form>
  </div>
  <div class="tabela-mobile">
    <app-card
      *ngIf="!isLoading"
      [data]="tableData"
      [rows]="tableColumns"
      [expand]="true" />
  </div>
</app-layout>

<app-loader [isLoading]="isLoading"></app-loader>
